import { render } from "./EditAccountModal.vue?vue&type=template&id=f89e5c7e"
import script from "./EditAccountModal.vue?vue&type=script&lang=js"
export * from "./EditAccountModal.vue?vue&type=script&lang=js"

import "./EditAccountModal.vue?vue&type=style&index=0&id=f89e5c7e&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__